class CollapsibleText extends HTMLElement {
  static get observedAttributes() {
    return ['data-collapsed-height'];
  }

  connectedCallback() {
    this.content = this.querySelector('.collapsible-text__content');
    this.button = this.querySelector('.collapsible-text__toggle');
    if (!this.content || !this.button) return;

    this.button.addEventListener('click', this.onToggle.bind(this));
    this.applyCollapsedState();
  }

  attributeChangedCallback() {
    // Lets the theme editor's height slider update the preview live
    // without needing a full section re-render.
    if (this.content && this.button) this.applyCollapsedState();
  }

  get collapsedHeight() {
    return parseInt(this.dataset.collapsedHeight, 10) || 96;
  }

  applyCollapsedState() {
    if (this.classList.contains('is-expanded')) {
      this.content.style.maxHeight = this.content.scrollHeight + 'px';
      return;
    }

    // Content shorter than the collapsed height: nothing to hide,
    // so there is no toggle button and no fade to show.
    if (this.content.scrollHeight <= this.collapsedHeight + 8) {
      this.button.hidden = true;
      this.classList.add('is-expanded');
      this.content.style.maxHeight = 'none';
      return;
    }

    this.button.hidden = false;
    this.content.style.maxHeight = this.collapsedHeight + 'px';
  }

  onToggle() {
    const expanded = this.classList.toggle('is-expanded');
    this.content.style.maxHeight = expanded
      ? this.content.scrollHeight + 'px'
      : this.collapsedHeight + 'px';
    this.button.setAttribute('aria-expanded', String(expanded));
  }
}

if (!customElements.get('collapsible-text')) {
  customElements.define('collapsible-text', CollapsibleText);
}
